/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DiscreteNumericValueDto } from './DiscreteNumericValueDto';
import {
    DiscreteNumericValueDtoFromJSON,
    DiscreteNumericValueDtoFromJSONTyped,
    DiscreteNumericValueDtoToJSON,
} from './DiscreteNumericValueDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface PhotonBeamQualityCombinationValueDto
 */
export interface PhotonBeamQualityCombinationValueDto {
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    beamQualityName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    beamQualityId?: string;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {DiscreteNumericValueDto}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    selectedDoseRate?: DiscreteNumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    radiationType?: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    energy?: NumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    highDoseTechniqueType?: EnumerationValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    primaryFluenceShaping?: EnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityCombinationValueDto
     */
    $type?: PhotonBeamQualityCombinationValueDtoTypeEnum;
}


/**
 * @export
 */
export const PhotonBeamQualityCombinationValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsPhotonBeamQualityCombinationValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.PhotonBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PhotonBeamQualityCombinationValueDtoTypeEnum = typeof PhotonBeamQualityCombinationValueDtoTypeEnum[keyof typeof PhotonBeamQualityCombinationValueDtoTypeEnum];



/**
 * Check if a given object implements the PhotonBeamQualityCombinationValueDto interface.
 */
export function instanceOfPhotonBeamQualityCombinationValueDto(value?: unknown): value is PhotonBeamQualityCombinationValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PhotonBeamQualityCombinationValueDtoTypeEnum)[0];
}

export function PhotonBeamQualityCombinationValueDtoFromJSON(json: any): PhotonBeamQualityCombinationValueDto {
    return PhotonBeamQualityCombinationValueDtoFromJSONTyped(json, false);
}

export function PhotonBeamQualityCombinationValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotonBeamQualityCombinationValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'beamQualityName': json['beamQualityName'] == null ? undefined : json['beamQualityName'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'beamQualityId': json['beamQualityId'] == null ? undefined : json['beamQualityId'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'selectedDoseRate': json['selectedDoseRate'] == null ? undefined : DiscreteNumericValueDtoFromJSON(json['selectedDoseRate']),
        'radiationType': json['radiationType'] == null ? undefined : EnumerationValueDtoFromJSON(json['radiationType']),
        'energy': json['energy'] == null ? undefined : NumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': json['highDoseTechniqueType'] == null ? undefined : EnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        'primaryFluenceShaping': json['primaryFluenceShaping'] == null ? undefined : EnumerationValueDtoFromJSON(json['primaryFluenceShaping']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PhotonBeamQualityCombinationValueDtoToJSON(value?: PhotonBeamQualityCombinationValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'beamQualityName': value['beamQualityName'],
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        'groupId': value['groupId'],
        'beamQualityId': value['beamQualityId'],
        'origin': EntityOriginToJSON(value['origin']),
        'selectedDoseRate': DiscreteNumericValueDtoToJSON(value['selectedDoseRate']),
        'radiationType': EnumerationValueDtoToJSON(value['radiationType']),
        'energy': NumericValueDtoToJSON(value['energy']),
        'highDoseTechniqueType': EnumerationValueDtoToJSON(value['highDoseTechniqueType']),
        'primaryFluenceShaping': EnumerationValueDtoToJSON(value['primaryFluenceShaping']),
        '$type': value['$type'],
    });
}

